// Import package
import { v4 } from "uuid";

// Import file
import {
  SET_DISCOUNT_TRAINING_OPTIONS,
  SET_DISCOUNT_TRAINING_OPTIONS_LOADING,
  DELETE_DISCOUNT_TRAINING_OPTION,
} from "../../constants/ActionTypes";
import { baseRequest } from "../../util/Api";
import {
  setLoadingMessage,
  setSuccessMessage,
  setErrorMessage,
} from "./Common";

// Method-method
export const createDiscountTrainingOption = (data) => (dispatch) =>
  new Promise((resolve, reject) => {
    const key = v4();
    dispatch(setLoadingMessage("Menambah diskon pilihan training ...", key));
    baseRequest("post", "/discount-training-options/", null, data)
      .then((newData) => {
        dispatch(setSuccessMessage("Menambah diskon pilihan training berhasil", key));
        resolve(newData);
      })
      .catch((e) => {
        dispatch(setErrorMessage(e, key));
        reject(e);
      });
  });

export const getDiscountTrainingOptions = (filter) => (dispatch) =>
  new Promise((resolve) => {
    dispatch({
      type: SET_DISCOUNT_TRAINING_OPTIONS_LOADING,
      payload: true,
    });
    baseRequest("get", "/discount-training-options/", filter)
      .then((data) => {
        dispatch({
          type: SET_DISCOUNT_TRAINING_OPTIONS,
          payload: data,
        });
        resolve(data);
      })
      .catch((e) => {
        dispatch(setErrorMessage(e));
        dispatch({
          type: SET_DISCOUNT_TRAINING_OPTIONS_LOADING,
          payload: false,
        });
      });
  });

export const deleteDiscountTrainingOption = (id) => (dispatch) =>
  new Promise((resolve, reject) => {
    const key = v4();
    baseRequest("delete", "/discount-training-options/" + id)
      .then(() => {
        dispatch({
          type: DELETE_DISCOUNT_TRAINING_OPTION,
          payload: id,
        });
        resolve();
      })
      .catch((e) => {
        dispatch(setErrorMessage(e, key));
        reject(e);
      });
  });
